export type ObjectId = string;

export enum ScoringTypeValue {
  NUMERIC = 'NUMERIC',
  DROPDOWN = 'DROPDOWN',
  TEXT = 'TEXT'
}

export interface ScoringType {
  id?: ObjectId;
  name: string;
  school: string;
  type?: ScoringTypeValue;
  validScores?: string[] | null;
  // Only meaningful when type is TEXT.
  maxLength?: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface ScoringTypeFormData {
  name: string;
  type: ScoringTypeValue;
  validScores: string[] | null;
  maxLength?: number;
  id?: ObjectId;
}

export interface ScoringTypeModalProps {
  fetchData: () => Promise<void>;
  open: boolean;
  onClose: () => void;
  scoringType?: ScoringType | null;
  onApiSuccessAndFailure: (isSuccess: boolean, message: string) => void;
}

export interface DeleteConfirmationProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  scoringTypeName: string;
}
